import { useMutation } from '@apollo/client';

import * as Types from '@xing-com/crate-common-graphql-types';
import { VompPlatformEnum } from '@xing-com/crate-common-graphql-types';
import {
  SwipeRecruiterProfileVisitDocument,
  type SwipeRecruiterProfileVisitMutation,
  type SwipeRecruiterProfileVisitMutationVariables,
} from '@xing-com/crate-dream-machine-graphql';
import { BREAKPOINTS, useMediaListener } from '@xing-com/util';

type UseVompReturnType = {
  callVomp: (userId: string) => Promise<void>;
};

export const useVomp = (): UseVompReturnType => {
  const matchedMedia = useMediaListener();
  const isHandheld = matchedMedia === BREAKPOINTS.handheld;

  const [mutateVomp] = useMutation<
    SwipeRecruiterProfileVisitMutation,
    SwipeRecruiterProfileVisitMutationVariables
  >(SwipeRecruiterProfileVisitDocument);

  const callVomp = async (userId: string): Promise<void> => {
    mutateVomp({
      variables: {
        userID: userId,
        clickReasonID: Types.ClickReasonsEnum.CrWebNetworkSearchSwipeView,
        platform: isHandheld
          ? VompPlatformEnum.WebSmallScreen
          : VompPlatformEnum.WebLargeScreen,
      },
    });
  };

  return { callVomp };
};
